// extracted by mini-css-extract-plugin
export default {"notice":"CensusNotice_notice__lLsSs"};